import {Injectable} from '@angular/core';
import {LocalStorageType} from '@portal/models/local-storage-type';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  setItem(key: string, value: string, type: LocalStorageType) {
    if (type === LocalStorageType.MANDATORY) {
      localStorage.setItem(key, value);
      return;
    }
    if (localStorage.getItem(LocalStorageType[LocalStorageType.ANALYTICS]) === 'true' && type === LocalStorageType.ANALYTICS) {
      localStorage.setItem(key, value);
      return;
    }
    if (localStorage.getItem(LocalStorageType[LocalStorageType.THIRDPARTY]) === 'true' && type === LocalStorageType.THIRDPARTY) {
      localStorage.setItem(key, value);
      return;
    }
    if (!type) {
      console.error('No type of local storage value defined!');
    }
  }

  getItem(key: string, defaultValue = null): unknown {
    const item = localStorage.getItem(key);
    if (!item) {
      return defaultValue;
    }
    try {
      return JSON.parse(item);
    } catch (e) {
      return defaultValue;
    }
  }
}
